var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-page-template',{attrs:{"title":"Connexion","message":"Authentifiez vous pour accéder à toutes les fonctionnalités du site."}},[_c('login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }